/* Collector */
class Collector {

	/* Collector.constructor */
	constructor() {
		this.busy = false;
		this.next = null;
	}

	/* Collector.get */
	get(requests) {
		if (this.busy) {
			this._add(requests);
		}
		else {
			this.busy = true;
			this._get(requests);
		}
	}

	/* _get */
	_get(requests) {
		Promise.all(
			requests.map(req => req[0].retrieve(req[1]))
		).then(
			() => {
				if (this.next) {
					const temp = this.next;
					this.next = null;
					this._get(temp);
				}
				else {
					this.busy = false;
				}
			}
		);
	}

	/* _add */
	_add(requests) {
		const temp = [];
		requests.forEach(
			request => {
				let params = request[1] ? JSON.stringify(request[1]) : '';
				if (this.next) {
					if (!this._check(request[0], params))
						temp.push([ request[0], request[1], params ]);
				}
				else {
					temp.push([ request[0], request[1], params ]);
				}
			}
		);
		if (temp.length)
			this.next = this.next ? [ ...this.next, ...temp ] : temp;
	}

	/* _check */
	_check(entity, params) {
		const ln = this.next.length;
		for (let i = 0; i < ln; i++)
			if (this.next[i][0] === entity && this.next[i][2] === params)
				return true;
		return false;
	}

};

/* EXPORT: collector */
export const collector = new Collector;
